import { Box, Typography } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { COLORS } from '../IndividualPlan/tokens';
import { REPORTS } from '../Reports/tokens';
import { PRIMARY_BUTTON_SX, TEXT_BUTTON_SX } from '../Samples/SampleBanner';
import type { StudentsBannerCopy } from './bannerState';

type Props = {
  copy: StudentsBannerCopy;
  onSeeSample: () => void;
  onUploadAccess?: () => void;
  onGoToDashboard: () => void;
  onGeneratePlans: () => void;
};

export function StudentsBanner({ copy, onSeeSample, onUploadAccess, onGoToDashboard, onGeneratePlans }: Props) {
  return (
    <Box
      component="section"
      role="region"
      aria-label={copy.label}
      data-testid="students-banner"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '20px 24px',
        borderRadius: '12px',
        bgcolor: REPORTS.welcome.bg,
      }}
    >
      <InfoOutlinedIcon sx={{ alignSelf: 'flex-start', flexShrink: 0, width: 24, height: 24, color: COLORS.navy }} />
      <Box sx={{ flex: '1 1 auto', minWidth: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <Typography component="h2" sx={{ fontSize: 16, lineHeight: '24px', fontWeight: 700, color: COLORS.ink }}>
          {copy.title}
        </Typography>
        <Typography sx={{ maxWidth: 640, fontSize: 16, lineHeight: '24px', fontWeight: 500, color: COLORS.muted }}>
          {copy.body}
        </Typography>
      </Box>
      {copy.kind !== 'waitingForAdmin' && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
          {copy.kind === 'noAccess' && (
            <Box component="button" type="button" onClick={onSeeSample} sx={{ ...TEXT_BUTTON_SX, border: 0, cursor: 'pointer' }}>
              See a sample plan
            </Box>
          )}
          {copy.kind === 'noAccess' && onUploadAccess && (
            <Box component="button" type="button" onClick={onUploadAccess} sx={PRIMARY_BUTTON_SX}>
              <FileUploadOutlinedIcon sx={{ fontSize: 20 }} />
              <span>Upload ACCESS files</span>
            </Box>
          )}
          {copy.kind === 'confirmSettings' && (
            <Box component="button" type="button" onClick={onGoToDashboard} sx={PRIMARY_BUTTON_SX}>
              Go to the Dashboard
            </Box>
          )}
          {copy.kind === 'readyToGenerate' && (
            <Box component="button" type="button" onClick={onGeneratePlans} sx={PRIMARY_BUTTON_SX}>
              Generate plans
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
